var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.showVideo),expression:"showVideo"}],staticStyle:{"max-width":"300px"},attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.mediaEntry[0]}})])}
var staticRenderFns = []

export { render, staticRenderFns }